import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { Kevlar2Component } from './kevlar2-validation.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        Kevlar2Component
    ],
    providers: [],
    exports: []
})
export class Kevlar2ValidationModule {}
